module.exports = __webpack_public_path__ + "img/mans.d61f08c0.png";